import React from 'react';

const SvgTextBox = (props) => (
  <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
    <path d="M2 4v6H1v4h1v6h20v-6h1v-4h-1V4H2zm2 2h16v4h-1v4h1v4H4v-4h1v-4H4V6zm5 2v2h2v6h2v-6h2V8H9z" />
  </svg>
);

export default SvgTextBox;
